export enum ExamDocumentTypeEnum {
  PRACTICAL = 1002,
  THEORY = 1003,
}
